import React from 'react';
import { Link } from 'react-router-dom';
import CTAButton from '../components/CTAButton';
import TestimonialCard from '../components/TestimonialCard';
import Newsletter from '../components/Newsletter';
import { Youtube } from 'lucide-react';
import ImageSlider from '../components/ImageSlider';
const HomePage = () => {
  const featuredProducts = [{
    id: 'cookbook',
    title: 'Jemi Baby Cookbook',
    description: "Nutritious and delicious recipes for your baby's developmental stages. This comprehensive cookbook includes 30 recipes specifically designed for babies from 6 months and above.",
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/rAkkvgbfh1SkzpzARSosJN/Jemi_Baby_Cookbook.png',
    link: 'https://selar.com/jemibabycookbook'
  }, {
    id: 'mealplanner',
    title: 'Jemi Baby Meal Planner',
    description: "Weekly meal planning made easy for busy moms. With a week of pre-planned meals, shopping lists, and preparation tips, you'll save time and ensure your baby gets a balanced diet with variety.",
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uDtBUFBW6Zd73xFL3XpRhA/Jemi_Baby_Meal_Planner.png',
    link: 'https://selar.com/jemibabymealplanner'
  }, {
    id: 'foodguide',
    title: 'Jemi Baby Food Guide',
    description: 'Complete guide to introducing solid foods to your baby.',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1Ja1LXkpPqvN6wNKVrJ6gG/Jemi_Baby_Food_Guide.png',
    link: 'https://selar.com/jemibabyfoodguide'
  }];
  return <div data-id="element-394">
      {/* Hero Section with Image Slider */}
      <section className="relative overflow-hidden" data-id="element-395">
        <ImageSlider data-id="element-396" />
      </section>
      {/* Featured Video Section */}
      <section className="py-12 bg-cream" data-id="element-397">
        <div className="container mx-auto px-4" data-id="element-398">
          <h2 className="text-2xl md:text-3xl font-bold text-brown mb-6 text-center" data-id="element-399">
            Watch Our Webinar
          </h2>
          <p className="text-gray-700 mb-8 text-center max-w-3xl mx-auto" data-id="element-400">
            Learn valuable insights about baby nutrition and meal planning in
            our "My Baby and Meals" webinar
          </p>
          <div className="relative pb-[56.25%] h-0 overflow-hidden max-w-4xl mx-auto rounded-lg shadow-lg" data-id="element-401">
            <iframe className="absolute top-0 left-0 w-full h-full" src="https://www.youtube.com/embed/Hp94_ZibIL0" title="My Baby and meals || Webinar || Jemi Baby Care" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen data-id="element-402"></iframe>
          </div>
        </div>
      </section>
      {/* YouTube Subscription Banner */}
      <section className="bg-beige py-6" data-id="element-403">
        <div className="container mx-auto px-4" data-id="element-404">
          <div className="flex justify-center" data-id="element-405">
            <a href="https://youtube.com/@jemibabycare" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 bg-red-600 text-white px-6 py-3 rounded-full hover:bg-red-700 transition-colors duration-300 inline-flex" data-id="element-406">
              <Youtube size={20} data-id="element-407" />
              <span data-id="element-408">Subscribe to our YouTube for more parenting tips</span>
            </a>
          </div>
        </div>
      </section>
      {/* Brand Introduction */}
      <section className="py-16 bg-cream" data-id="element-409">
        <div className="container mx-auto px-4 text-center max-w-3xl" data-id="element-410">
          <h2 className="text-2xl md:text-3xl font-bold text-brown mb-6" data-id="element-411">
            Welcome to Jemi Baby Care
          </h2>
          <p className="text-gray-700 mb-8 text-lg" data-id="element-412">
            At Jemi Baby Care, we believe every mom deserves access to reliable
            information and resources to raise healthy, happy babies. Our guides
            are created by moms, for moms, with expert input to ensure you have
            everything you need on your parenting journey.
          </p>
          <Link to="/about" className="text-brown font-medium hover:text-brown-dark underline" data-id="element-413">
            Learn more about our story
          </Link>
        </div>
      </section>
      {/* Featured Products */}
      <section className="py-16 bg-white" data-id="element-414">
        <div className="container mx-auto px-4" data-id="element-415">
          <h2 className="text-2xl md:text-3xl font-bold text-brown mb-2 text-center" data-id="element-416">
            Our Featured Products
          </h2>
          <p className="text-gray-700 mb-12 text-center" data-id="element-417">
            Trusted resources to support you on your motherhood journey
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-418">
            {featuredProducts.map(product => <div key={product.id} className="bg-cream rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300" data-id="element-419">
                <a href={product.link} target="_blank" rel="noopener noreferrer" className="block p-4" data-id="element-420">
                  <div className="aspect-w-3 aspect-h-4 mb-4" data-id="element-421">
                    <img src={product.imageUrl} alt={product.title} className="object-contain w-full h-64" data-id="element-422" />
                  </div>
                  <h3 className="text-xl font-bold text-brown mb-2" data-id="element-423">
                    {product.title}
                  </h3>
                  <p className="text-gray-600 mb-4" data-id="element-424">{product.description}</p>
                  <span className="text-brown font-medium hover:text-brown-dark" data-id="element-425">
                    Learn more →
                  </span>
                </a>
              </div>)}
          </div>
          <div className="text-center mt-12" data-id="element-426">
            <CTAButton text="View All Products" link="/shop" data-id="element-427" />
          </div>
        </div>
      </section>
      {/* Testimonials */}
      <section className="py-16 bg-beige" data-id="element-428">
        <div className="container mx-auto px-4" data-id="element-429">
          <h2 className="text-2xl md:text-3xl font-bold text-brown mb-2 text-center" data-id="element-430">
            What Moms Are Saying
          </h2>
          <p className="text-gray-700 mb-12 text-center" data-id="element-431">
            Join hundreds of satisfied moms in our community
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-432">
            <TestimonialCard quote="Jemi Baby Care has been more than just a platform for me as a first-time mom—it has been a source of strength, guidance, and comfort. I love that it beautifully combines prayer, self-care, and baby care, reminding me that nurturing myself is just as important as nurturing my baby." name="Elizabeth O." role="First-time mom" data-id="element-433" />
            <TestimonialCard quote="My experience with this community has been amazing. I love how they are swift in replying to ones complain and also bringing solution to it. All that has been taught here have really worked for me.. Thank you so much Jemi baby care." name="Jane" role="First-time mom" data-id="element-434" />
            <TestimonialCard quote="As a first-time pregnant woman, I had been searching for a support group that could walk with me through the joys and challenges of pregnancy and early motherhood. I prayed earnestly, seeking guidance, and I believe the Holy Spirit led me to the Jemi Baby Moms community." name="Adaora A.O" role="First-time mom" data-id="element-435" />
            <TestimonialCard quote="What has stood out for me so far in Jemi Moms Community is the ability to pray the right type of prayers backed up with the word. This has really helped me even when I'm praying on my own. Also I learn to be more intentional about my child's health as regards what he eats." name="Faith I." role="First-time mom" data-id="element-436" />
          </div>
        </div>
      </section>
      {/* Newsletter */}
      <section className="py-16 bg-cream" data-id="element-437">
        <div data-id="element-438">
          <Newsletter data-id="element-439" />
        </div>
      </section>
    </div>;
};
export default HomePage;